import React from 'react'
import ApiUrl from '../../../../configTools/apiUrl'
import { useState,useEffect } from 'react'
import Button from '../../../../components/forms/blackfillButton'

const Fys = () => {
    const [fysImage,setFysImage] = useState('');
    const [fysTitle,setFysTitle] = useState('');
    const [fysDetails,setFysDetails] = useState('');
    useEffect(()=>{
        fetch(ApiUrl.API_URL_Page+"/1/2")
        .then(res=>res.json())
        .then(data =>{
          if(data.length !== 0){
              setFysImage(data[0].value);
          }
        });
        fetch(ApiUrl.API_URL_Page+"/1/3")
        .then(res=>res.json())
        .then(data =>{
          if(data.length !== 0){
              setFysTitle(data[0].value);
          }
        });
        fetch(ApiUrl.API_URL_Page+"/1/4")
        .then(res=>res.json())
        .then(data =>{
          if(data.length !== 0){
              setFysDetails(data[0].value);
          }
        });
    },[])
  return (
    <div className='public_home_explore_fys'>
        <div className='public_home_explore_fys_container'>
            <div className='public_home_explore_fys_image'>
                <img src={ApiUrl.API_URL_Image_HD+fysImage} alt='Fys' />
            </div>
            <div className='public_home_explore_fys_td'>
                <div>
                    <h3>{fysTitle}</h3>
                    <p>{fysDetails}</p>
                    <div style={{padding:"20px 0px"}}>
                        <Button Value={'Shop Now'}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Fys
